import { getField, updateField } from "vuex-map-fields";
import trsaccInfoInpt from "./trsaccInfoInpt";
import otrbnkTrsaccInfoInpt from "./otrbnkTrsaccInfoInpt";
import napasTrsaccInfoInpt from "./napasTrsaccInfoInpt";
import autoTrsaccInfoInpt from "./autoTrsaccInfoInpt";
import autoTrsaccRegiHist from "./autoTrsaccRegiHist";
import cbmnetTrsaccInfoInpt from "./cbmnetTrsaccInfoInpt";

const getDefaultState = () => {
  return {
    RBF0400A40: {
      drwot: null, //출금계좌
      mnrcv: null, //자주쓰는계좌
    },
    RBF0405G40: null, //즉시이체결과조회
    RBF0405T40: null, //타행이체신청내역조회
    RBF0405T41: null, //타행이체신청내역조회(CBM-NET2)
    RBF0408W40: null, //현지은행목록조회
    drwotAcno: "", //선택된 출금계좌 정보
    initDrwotAcno: {}, //init계좌정보,
    isAmount: false, // myQR에서 금액추가 버튼 클릭여부 
    isShowAmt: true, // 금액추가 버튼 지우기 + 미지정~1,000,000 내용 지우기
    arrowNone: false, // 계좌번호 선택했을때 true로 바뀌면서 화살표가 빠짐

  };
};

const transfer = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    actAllStateReset({ commit }) {
      commit("resetState");
      commit("trsaccInfoInpt/resetState");
      commit("otrbnkTrsaccInfoInpt/resetState");
      commit("napasTrsaccInfoInpt/resetState");
      commit("autoTrsaccInfoInpt/resetState");
      commit("autoTrsaccRegiHist/resetState");
      commit("cbmnetTrsaccInfoInpt/resetState");
    },
  },
  modules: {
    trsaccInfoInpt,
    otrbnkTrsaccInfoInpt,
    napasTrsaccInfoInpt,
    autoTrsaccInfoInpt,
    autoTrsaccRegiHist,
    cbmnetTrsaccInfoInpt,
  },
};

export default transfer;
